import { DocumentResult } from "./document-result";

export interface CurateSearchResult  {
    documents: DocumentResult[];
    returnDocumentCount: number;
    totalDocumentResultSetCount:number
}